import { trackingClient } from '../clients'
import { TrackingEventTypeEnum } from '../common/enum'
import { FormatDateFunction, TranslationFunction } from '../common/types'
import { SearchbarFieldsReturn } from '../components/property-details/hooks/use-searchbar'
import { FormattedLivePricingDataTransport } from '../models/pricing/live-pricing-formatter'
import { CookieManagerService } from '../services'
import { TrackingEvent } from '../transports/tracking-transport'
import get from 'lodash/get'

export const trackEvents = (events: TrackingEvent[]) => {
    trackingClient.trackEvents({ trackingEvents: events }).then()
}

export function trackSrlObjectClick({
    listingId,
    searchbar,
    pricingDetails,
    pricingErrorCode,
    t,
    format,
}: {
    listingId: string
    searchbar: SearchbarFieldsReturn
    pricingDetails: FormattedLivePricingDataTransport | null
    pricingErrorCode: number | null
    t: TranslationFunction
    format: FormatDateFunction
}) {
    const cookieKey = `srlObjectClicked_${listingId}`
    const componentCookieKey = `srlObjectClicked_${listingId}_componentName`

    const srlReferer = CookieManagerService.getCookie(cookieKey)
    const componentName = CookieManagerService.getCookie(componentCookieKey)

    const filters = {
        arrival_date: searchbar.arrival ? format(searchbar.arrival, 'yyyy-MM-dd') : null,
        departure_date: searchbar.departure ? format(searchbar.departure, 'yyyy-MM-dd') : null,
        adult: searchbar.adults,
        children: searchbar.kids,
    }

    const listing = {
        tfw_object_id: listingId,
        availability: pricingErrorCode ? 'not_available' : pricingDetails?.price ? 'available' : 'on_request',
        final_price: get(pricingDetails, 'formattedPrice'),
        error_message: pricingErrorCode ? t(`livePriceErrors.${pricingErrorCode}`) : '',
        component: componentName || '',
    }

    const eventData = {
        url: srlReferer,
        timestamp: new Date(),
        filters,
        listing,
    }

    trackEvents([
        {
            eventType: TrackingEventTypeEnum.EVENT_RESULT_OBJECT_CLICK,
            eventValue: Number(listingId),
            eventData: eventData,
        },
    ])

    CookieManagerService.deleteCookie(cookieKey)
    CookieManagerService.deleteCookie(componentCookieKey)
}
